import script from "./TopNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavBar.vue?vue&type=script&setup=true&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=18b8c7f6&lang=scss"

const __exports__ = script;

export default __exports__